
<template>
  <div
    v-if="errors.first(`${form}.${id}`)"
    class="invalid-tooltip">
    {{ errors.first(`${form}.${id}`) }}
  </div>
</template>

<script>
import getParentFormId from '@/helpers/forms/getParentFormId';

export default {
  inject: ['$validator'],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: '',
    };
  },
  created() {
    this.form = getParentFormId(this);
  },
};
</script>
